<div class="recommendations-form border-r-16 no-gutters" *transloco="let t">
  <form class="col" *ngIf="supportingMeasureOptions$ | async as supportingMeasureOptions" [formGroup]="form" (ngSubmit)="onSubmit()">
    <ng-container *ngIf="spzRecommendations?.controls?.length === 0">
      <div class="text-center text-muted py-5">
        <i class="material-symbols-rounded d-block mb-2" aria-hidden="true">info</i>
        <div>{{ t('child/noSpzRecommendations') }}</div>
        <!-- optional helper -->
        <small class="d-block mt-1">{{ t('child/clickAddToCreateRecommendation') }}</small>
      </div>
    </ng-container>

    <div class="row no-gutters mb-4" *ngFor="let spzRecommendation of spzRecommendations.controls; let i = index">
      <div class="col-12">
        <app-child-spz-recommendation-form
          [formGroup]="spzRecommendation"
          [allowRemove]="true"
          [supportingMeasureOptions]="supportingMeasureOptions"
          (remove)="removeRecommendation(i)"
        ></app-child-spz-recommendation-form>
        <hr *ngIf="i < spzRecommendations.controls.length - 1" />
      </div>
    </div>
    <hr />
    <div class="row no-gutters">
      <div class="d-flex justify-content-between align-items-center gap-4">
        <button type="button" class="btn btn-lg btn-icon btn-outline-primary" (click)="addRecommendation()">
          <i class="material-symbols-rounded">add</i>
          {{ t('child/addSpzRecommendation') }}
        </button>
        <div class="col text-center d-flex justify-content-end gap-2">
          <button type="button" (click)="onCancel()" class="btn btn-lg btn-outline-primary">
            {{ t('child/cancel') }}
          </button>
          <button class="btn btn-lg btn-icon btn-primary" [disabled]="form.invalid || savingRecommendations">
            <div *ngIf="savingRecommendations" class="spinner-border spinner-border-sm" role="status"></div>
            {{ t('shared/save') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
